/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';

function FormInput({ labelFor, label, placeholder, id, type, gridClass, required }) {
    // STATES
    const [input, setInput] = useState('');
    // HANDLER
    const onChangeHandler = (e) => {
        setInput(e.target.value);
    };
    return (
        <div className={gridClass || 'col-md-6 col-12'}>
            <div className="single-personal-info">
                <label htmlFor={labelFor}>
                    {label} {required && <span style={{ color: 'red' }}>*</span>}
                </label>
                <input
                    value={input}
                    onChange={onChangeHandler}
                    type={type}
                    id={id}
                    placeholder={placeholder}
                    required={required}
                />
            </div>
        </div>
    );
}

export default FormInput;
